import { useState, useCallback } from 'react';

class VideoManager {
  constructor() {
    this.videoIdPatterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
      /youtu\.be\/([^?\n#]+)/
    ];
  }

  extractVideoId(url) {
    if (!url) return null;
    
    let videoId = null;
    for (const pattern of this.videoIdPatterns) {
      const match = url.match(pattern);
      if (match && match[1] && match[1].length === 11) {
        videoId = match[1];
        break;
      }
    }
    
    if (!videoId) {
      console.error('Could not extract video ID from URL:', url);
      return null;
    }
    
    // Extract time parameter (t=)
    const timeMatch = url.match(/[?&]t=(\d+)([smh])?/);
    let startTime = 0;
    
    if (timeMatch) {
      const timeValue = parseInt(timeMatch[1]);
      const timeUnit = timeMatch[2] || 's'; // Default to seconds if no unit specified
      
      switch (timeUnit) {
        case 's':
          startTime = timeValue;
          break;
        case 'm':
          startTime = timeValue * 60;
          break;
        case 'h':
          startTime = timeValue * 3600;
          break;
        default:
          startTime = timeValue;
      }
      
      console.log(`Extracted start time: ${startTime} seconds (${timeMatch[1]}${timeUnit})`);
    }
    
    return { videoId, startTime };
  }
}

export const useVideoManager = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  
  // Create a single instance of VideoManager
  const videoManager = useCallback(() => {
    if (!videoManager.instance) {
      videoManager.instance = new VideoManager();
    }
    return videoManager.instance;
  }, []);

  const handleBubbleClick = useCallback((thought) => {
    console.log('Bubble clicked:', thought);
    console.log('Thought text:', thought.thought || thought.text);
    console.log('Author:', thought.author);
    console.log('Thought ID:', thought.id);
    console.log('YouTube link:', thought.url || thought.youtubeLink);
    console.log('Full thought object:', JSON.stringify(thought, null, 2));
    
    // Use the new 'url' field or fallback to 'youtubeLink' for backward compatibility
    const videoUrl = thought.url || thought.youtubeLink;
    
    // Extract video ID and start time from YouTube URL
    const videoData = videoManager().extractVideoId(videoUrl);
    console.log('Extracted video data:', videoData);
    
    if (videoData && videoData.videoId) {
      setSelectedVideo({ 
        id: videoData.videoId, 
        startTime: videoData.startTime,
        youtubeLink: videoUrl,
        thought: thought.thought || thought.text,
        author: thought.author
      });
      setIsPlayerOpen(true);
      console.log('Opening video player for:', videoData.videoId, 'at time:', videoData.startTime);
    } else {
      console.error('Failed to extract video ID from:', videoUrl);
      console.error('Thought object structure:', Object.keys(thought));
    }
  }, [videoManager]);

  const closePlayer = useCallback(() => {
    setIsPlayerOpen(false);
    setSelectedVideo(null);
  }, []);

  return {
    selectedVideo,
    isPlayerOpen,
    handleBubbleClick,
    closePlayer
  };
};
